import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Empty, Pagination, Table } from "antd";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import config from "../../../config";
import User from "../../../assets/img/icons/user3.png";
import EmployeeSalaryDetail from "./EmployeeSalaryDetail";
import api from "../../../api/axios";
import { getEmployeesSalary } from "../../../services/salaryServices";
import EmployeeSalaryToExcel from "../../../components/EmployeeSalaryToExcel";
import { companyID, getEmployeeLocalDetails } from "../../../auth";
import TooltipWrapper from "../../../utils/TooltipWrapper";
import SalaryAcknowledgmentModal from "../../../components/SalaryAcknowledgmentModal";
import FilterComponent from "../../../components/FilterComponent";
import { getDepartmentById } from "../../../services/departmentService";

const EmployeesSalary = () => {
  const loginEmployeeDetails = getEmployeeLocalDetails();
  const [showSalaryDetail, setShowSalaryDetail] = useState(false);
  const [salaryDetail, setSalaryDetail] = useState([]);
  const [selectedEmployeeDetail, setSelectedEmployeeDetail] = useState([]);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [employeesSalary, setEmployeesSalary] = useState([]);
  const [error, setError] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showModal, setShowModal] = useState(false);
  const [filterOptions, setFilterOptions] = useState([
    { key: "Active", label: "status", value: [1], category: "Status" },
    { key: "Inactive", label: "status", value: [0], category: "Status" },
    { key: "All Employees", label: "status", value: null, category: "Status" },
  ]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentFilters, setCurrentFilters] = useState({ status: 1 });
  const navigate = useNavigate();

  const company_id = companyID();

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const selectedDetails = salaryDetail?.slice(startIndex, endIndex);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const fetchEmployeesSalary = (params = { status: 1 }) => {
    if (
      !loginEmployeeDetails ||
      !loginEmployeeDetails.employee_role ||
      (loginEmployeeDetails.employee_role != 1 &&
        !loginEmployeeDetails.working_departments?.length)
    ) {
      setEmployeeDetails([]);
      setSalaryDetail([]);
      return;
    }
    let finalParams = { ...params };
    if (
      loginEmployeeDetails.employee_role != 1 &&
      loginEmployeeDetails.working_departments?.length
    ) {
      if (!("department_id" in finalParams))
        finalParams.department_id = loginEmployeeDetails.working_departments;
    }

    const queryParams = new URLSearchParams();
    Object.entries(finalParams).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          if (val !== null && val !== undefined && val !== "") {
            queryParams.append(key, val);
          }
        });
      } else {
        queryParams.append(key, value);
      }
    });
    api
      .get(`employees-salary/${company_id}?${queryParams.toString()}`)
      .then((res) => {
        const seen = new Set();
        const salaryData = res.data.data.filter((employee) =>
          seen.has(employee.employee_id)
            ? false
            : seen.add(employee.employee_id)
        );
        setEmployeeDetails(res.data.data);
        setSalaryDetail(salaryData);
      })
      .catch((err) => {
        console.error(err);
        setEmployeeDetails([]);
        setSalaryDetail([]);
      })
      .finally(() => {
        //loader
      });
  };

  useEffect(() => {
    if (company_id) {
      fetchEmployeesSalary();
    }
  }, [showModal, showSalaryDetail]);

  const fetchDepartments = async () => {
    try {
      const departments = await getDepartmentById(company_id);
      if (!departments?.result?.length) {
        return;
      }
      const mappedDepartments = departments.result
        .filter((dept) => {
          if (
            loginEmployeeDetails.employee_role != 1 &&
            loginEmployeeDetails.working_departments?.length
          ) {
            return loginEmployeeDetails?.working_departments?.includes(dept.id);
          } else if (loginEmployeeDetails.employee_role == 1) {
            return true;
          } else {
            return false;
          }
        })
        .map((dept) => ({
          key: dept.department_name,
          label: "department_id",
          value: dept.id,
          category: "Department",
        }));

      setFilterOptions((prevOptions) => [...prevOptions, ...mappedDepartments]);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (company_id) {
        fetchEmployeesSalary({ ...currentFilters, search: searchTerm });
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchTerm, company_id, currentFilters]);

  const getNameOfEmployee = () => {
    if (selectedEmployeeDetail.length > 0) {
      const middle_name = selectedEmployeeDetail[0].middle_name
        ? selectedEmployeeDetail[0].middle_name + " "
        : "";
      return (
        selectedEmployeeDetail[0].first_name +
        " " +
        middle_name +
        selectedEmployeeDetail[0].last_name
      );
    }
    return "Employee";
  };

  function createEmployeeMap(employees) {
    const employeeMap = new Map();
    employees.forEach((employee) => {
      if (!employeeMap.has(employee.employee_id)) {
        employeeMap.set(employee.employee_id, []);
      }
      employeeMap.get(employee.employee_id).push(employee);
    });
    return employeeMap;
  }

  function getEmployeeDataById(employeeMap, employee_id) {
    return employeeMap.get(employee_id) || [];
  }

  const filterSelectedEmployeeDetail = (selectedEmployee, employeeId) => {
    const employeeMap = createEmployeeMap(selectedEmployee);
    const employeeData = getEmployeeDataById(employeeMap, employeeId);

    return employeeData;
  };

  useEffect(() => {
    getNameOfEmployee();
  }, [selectedEmployeeDetail]);

  const fetchSelectedMonthSalary = async (month) => {
    try {
      const res = await getEmployeesSalary(company_id, month);
      setEmployeesSalary(res.data);
      setError((prev) => ({ ...prev, salaryDetails: null }));
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setEmployeesSalary([]);
        setError((prev) => ({
          ...prev,
          salaryDetails: error.response.data.message,
        }));
      }
      console.error(error);
    } finally {
    }
  };

  const salaryActions = [
    {
      tooltip: "Send salary data on mail to management.",
      icon: "fa fa-paper-plane",
      text: "Send Salary Data",
      onClick: handleShow,
    },
    {
      tooltip: "Send salary credited notification to employees.",
      icon: "fa-solid fa-bell",
      text: "Notify Salary Credit",
      onClick: () => setShowModal(true),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle={
              showSalaryDetail
                ? `${getNameOfEmployee()} Salary Details`
                : "Employees Salary"
            }
            title={showSalaryDetail ? "Employees Salary" : "Dashboard"}
            subtitle={
              showSalaryDetail ? getNameOfEmployee() : "Employees Salary"
            }
            titleLink={showSalaryDetail ? "employees-salary" : null}
            onBackButton={() => {
              showSalaryDetail ? setShowSalaryDetail(false) : navigate(-1);
            }}
          />

          <div className="d-flex justify-content-between align-items-center mb-3">
            {!showSalaryDetail && (
              <div style={{ position: "relative", width: 380, maxWidth: "100%" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by employee name or official email"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    paddingRight: "2.2rem",
                    paddingLeft: "1rem",
                    height: "40px",
                    border: "1.5px solid var(--company-theme)", 
                    boxShadow: "none",
                    fontSize: "15px", 
                    transition: "border-color 0.2s",
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "var(--company-theme)")}
                  onBlur={(e) => (e.target.style.borderColor = "var(--company-theme)")}
                />
                <span
                  style={{
                    position: "absolute",
                    right: 16,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "var(--company-theme)",
                    fontSize: "18px",
                    pointerEvents: "none",
                  }}
                >
                  <i className="fa fa-search" />
                </span>
              </div>
            )}
            <div className="d-flex align-items-center">
              {salaryActions.map(({ tooltip, icon, text, onClick }, index) => (
                <TooltipWrapper key={index} tooltipText={tooltip}>
                  <button
                    className="btn btn-outline-primary me-2"
                    onClick={onClick}
                  >
                    <i className={`${icon} me-1`} />
                    {text}
                  </button>
                </TooltipWrapper>
              ))}
              {!showSalaryDetail ? (
                <TooltipWrapper tooltipText="Filter">
                  <FilterComponent
                    filterOptions={filterOptions}
                    onApplyFilter={(selectedFilter) => {
                      const queryParams = Object.entries(selectedFilter)?.length
                        ? selectedFilter
                        : { status: 1 };
                      setCurrentFilters(queryParams);
                      fetchEmployeesSalary({
                        ...queryParams,
                        search: searchTerm,
                      });
                    }}
                    filterLabel="Filter Employees"
                    resetLabel="Reset Filter"
                    applyLabel="Apply"
                  />
                </TooltipWrapper>
              ) : (
                <></>
              )}
            </div>
          </div>
          {!showSalaryDetail ? (
            <>
              <div className="row">
                {selectedDetails.length <= 0 ? (
                  <Empty description="No salary details available." />
                ) : (
                  selectedDetails.map((detail) => (
                    <div
                      className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3"
                      key={detail.id}
                    >
                      <div className="profile-widget">
                        <div className="profile-img">
                          <Link
                            to="#"
                            className="avatar"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowSalaryDetail(true);
                              const employeeData = filterSelectedEmployeeDetail(
                                employeeDetails,
                                detail.employee_id
                              );
                              setSelectedEmployeeDetail(employeeData);
                            }}
                          >
                            <img
                              src={
                                detail.photo
                                  ? `${config.IMAGE_URL}${detail.photo}`
                                  : User
                              }
                              alt=""
                            />
                          </Link>
                        </div>
                        <h4 className="user-name m-t-10 mb-0 text-ellipsis">
                          <Link
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setShowSalaryDetail(true);
                              const employeeData = filterSelectedEmployeeDetail(
                                employeeDetails,
                                detail.employee_id
                              );
                              setSelectedEmployeeDetail(employeeData);
                            }}
                          >
                            {detail?.first_name} {detail?.middle_name}{" "}
                            {detail?.last_name}
                          </Link>
                        </h4>
                        <div className="small text-muted">
                          {detail?.designation_name
                            ? detail?.designation_name
                            : "-"}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
              {salaryDetail?.length > 0 && (
                <div className="d-flex justify-content-end mb-4">
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={salaryDetail.length}
                    onChange={handlePageChange}
                    showSizeChanger={true}
                    pageSizeOptions={[4, 8, 12, 16, 20, 24]}
                    showLessItems={true}
                  />
                </div>
              )}
            </>
          ) : (
            <EmployeeSalaryDetail
              selectedEmployeeDetail={selectedEmployeeDetail}
            />
          )}
          {/* /Page Content */}
          {/* <AllEmployeeAddPopup /> */}
          <DeleteModal Name="Delete Employee" />
        </div>
      </div>
      <EmployeeSalaryToExcel
        show={show}
        handleClose={handleClose}
        employeesSalary={employeesSalary}
        fetchEmployeesSalary={fetchSelectedMonthSalary}
        error={error}
        setError={setError}
        setEmployeesSalary={setEmployeesSalary}
        sendEmail={true}
      />
      <SalaryAcknowledgmentModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        salaryData={employeeDetails}
      />
    </div>
  );
};

export default EmployeesSalary;
